import { CLEAR_DATA_FORGOT_PASSWORD, FORGOT_PASSWORD_REQUEST, FORGOT_PASSWORD_REQUEST_ERROR, FORGOT_PASSWORD_REQUEST_SUCCESS, REDIRECT_PAGE_FROM_FORGOT_PASSWORD } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const forgotPasswordReducer = (state = initialState, action) => {
    switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:        
        return { ...state, payload : action.payload, loading: true };
    case FORGOT_PASSWORD_REQUEST_SUCCESS :       
        return { ...state, successMsg : action.msg, loading: false };
    case FORGOT_PASSWORD_REQUEST_ERROR :
        return { ...state,loading: false };
    case REDIRECT_PAGE_FROM_FORGOT_PASSWORD :
        return {...state, url : action.url};
    case CLEAR_DATA_FORGOT_PASSWORD:
        return {...state, url : null};
    default:
        return state;
    }
};
  